// Builder analytics (PostHog). Loaded lazily after the builder starts, so it never slows the first
// paint. Events sent before PostHog finishes loading are queued and sent once it's ready.
// No names or emails are sent; visitors stay anonymous.
const POSTHOG_KEY = 'phc_o56nhivuHpXijEzZfs7gqb8VjH5iS2vEzwmM6hBTU2dc' // public project key (send-only)
const POSTHOG_HOST = 'https://us.i.posthog.com'

let ph = null
let loading = null
const queue = []

export function initAnalytics() {
  if (loading || typeof window === 'undefined') return loading
  loading = import(/* webpackChunkName: "posthog" */ 'posthog-js')
    .then(({ default: posthog }) => {
      posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: 'identified_only', // anonymous visitors, no person profiles
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: true, // clicks, for heatmaps
        enable_heatmaps: true,
        capture_exceptions: true, // builder crashes and errors, with device and browser
        session_recording: {
          maskAllInputs: true // never record what people type (emails, passwords)
        }
      })
      posthog.register({ app: 'builder' })
      // Team devices: open the builder once with ?ohma_team=1 (or ?ohma_team=0 to undo) and that
      // browser's visits are tagged internal, so reports can leave them out
      try {
        const flag = new URLSearchParams(window.location.search).get('ohma_team')
        if (flag === '1') localStorage.setItem('ohma_team', '1')
        if (flag === '0') localStorage.removeItem('ohma_team')
        if (localStorage.getItem('ohma_team') === '1') posthog.register({ internal: true })
        else posthog.unregister('internal')
      } catch (e) {}
      ph = posthog
      queue.splice(0).forEach(([event, props, opts]) => ph.capture(event, props, opts))
      return posthog
    })
    .catch(() => null)
  return loading
}

// track('event_name', { ...props }, { beacon: true }) - beacon for events right before leaving the page
export function track(event, props = {}, { beacon = false } = {}) {
  try {
    const opts = beacon ? { transport: 'sendBeacon', send_instantly: true } : undefined
    if (ph) ph.capture(event, props, opts)
    else queue.push([event, props, opts])
  } catch (e) {}
}

// Readable names for the options people change
export function colorLabel(hex, names) {
  if (!hex) return null
  const name = names?.[hex] ?? names?.[String(hex).toLowerCase()]
  if (name) return name
  return /^#[0-9a-f]{3,8}$/i.test(hex) ? 'Custom hex color' : hex
}
